export default __webpack_public_path__ + "static/media/Anoma.cb18e708.png";